<script>
import CandidateList from '@/components/candidate/candidate-list.vue'
import CandidateListSkeleton from '@/components/skeleton/candidate-list-skeleton.vue'
import CandidateZoom from '@components/candidate/candidate-zoom.vue'
import Layout from '@layouts/main.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CandidatesView',
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: 'The Candidates page.' }],
    }
  },
  components: { Layout, CandidateList, CandidateZoom, CandidateListSkeleton },
  data: function() {
    return {
      candidateList: [],
      showCandidateModal: false,
    }
  },
  computed: {
    ...mapGetters({
      getSelectedClients: 'client/getSelectedClients',
      isCanListLoading: 'candidate/isCanListLoading',
    }),
  },
  watch: {
    async getSelectedClients(clientIds) {
      await this.loadCandidateList(clientIds)
    },
  },
  async created() {
    await this.loadCandidateList(this.getSelectedClients)
  },
  methods: {
    ...mapActions({
      getCandidateList: `candidate/getCandidateListByClientIds`,
    }),
    async loadCandidateList(selectedClients = []) {
      if (!selectedClients || selectedClients.length === 0) {
        this.candidateList = []
        return
      }

      const result = await this.getCandidateList(selectedClients)

      if (!result.isSuccess && result.statusCode === 403) {
        alert(this.$t('candidateList.candidateListUnauthorisedError'))
        this.$router.push('/')
      }

      if (result.isSuccess) {
        const list = []
        for (const data of result.data) {
          list.push({
            ...data,
            profileImgSrc: null,
          })
        }
        this.candidateList = list
      }
    },
    showCandidateDialog(candidateId) {
      this.selectedCandidate = candidateId
      this.showCandidateModal = true
    },
    closeCandidateDialog() {
      this.selectedCandidate = null
      this.showCandidateModal = false
    },
  },
}
</script>

<template>
  <Layout>
    <BasePageHeader :title="$t('candidates.pageTitle')" />
    <section>
      <CandidateListSkeleton v-if="isCanListLoading" />
      <CandidateList
        v-else-if="candidateList.length > 0"
        :candidate-data="candidateList"
        @viewCandidate="showCandidateDialog"
      ></CandidateList>
    </section>

    <v-dialog
      v-if="showCandidateModal"
      v-model="showCandidateModal"
      width="720px"
      content-class="rounded-xl"
    >
      <CandidateZoom
        :id="selectedCandidate"
        @closeModal="closeCandidateDialog"
      />
    </v-dialog>
  </Layout>
</template>
